const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
export const BACKEND_BASE_URL = API_URL.replace(/\/api\/v1\/?$/, '');

/**
 * Formats a media URL (image, audio, video).
 * If the URL is already absolute (http://, https://, data:), returns it as is.
 * If the URL is relative (/storage/...), prefixes with the configured backend base URL.
 */
export function formatMediaUrl(url?: string | null): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const cleanPath = url.startsWith('/') ? url : `/${url}`;
  return `${BACKEND_BASE_URL}${cleanPath}`;
}
